import { PromoEnginePreviewResponseDataAttributes } from '@/api'

/**
 * Slice "base" dello state Pinia del promo-engine.
 */
export type BaseState = {
  test: string
  previewPromoEngine: Array<PromoEnginePreviewResponseDataAttributes>
}

export const createBaseState = (): BaseState => ({
  test: '',
  previewPromoEngine: [],
})
